/**
 * Line-level [image:<uuid>] token matcher (spec
 * docs/superpowers/specs/2026-08-26-image-generation-inline-design.md §3.4).
 * Tolerant of surrounding whitespace and stray backticks (models/markdown can
 * decorate); strict on everything else — an embedded mid-sentence token is
 * NOT a visual, it renders as prose. Extracted from MessageBubble.jsx so
 * `node --test` can load it (same precedent as mermaidNormalize.js).
 */
const TOKEN_RE = /^\s*`?\[image:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\]`?\s*$/i;

export function matchImageToken(line) {
  const m = String(line ?? '').match(TOKEN_RE);
  return m ? m[1] : null;
}

/**
 * Fence-aware extraction: pull [image:] token LINES out of text, skipping any
 * line inside a ``` fence — a token quoted in a code block stays literal
 * (review finding 2026-08-27). Returns the remaining text and ids in order.
 * @param {string} text
 * @returns {{ text: string, ids: string[] }}
 */
export function extractImageVisuals(text) {
  const src = String(text ?? '');
  if (!src.includes('[image:')) return { text: src, ids: [] };
  const kept = [];
  const ids = [];
  let inFence = false;
  for (const line of src.split('\n')) {
    if (/^\s*```/.test(line)) { inFence = !inFence; kept.push(line); continue; }
    const id = !inFence ? matchImageToken(line) : null;
    if (id) ids.push(id);
    else kept.push(line);
  }
  return { text: kept.join('\n'), ids };
}
